export const DEFAULT_LAT = 37.5466848;
export const DEFAULT_LNG = 127.0477368;
